import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import NoticeService from "../../services/notice.service";

/* =================== Thunks =================== */

export const getNotice = createAsyncThunk(
  "notice/getNotice",
  async (item, thunkAPI) => {
    try {
      const response = await NoticeService.getNotice(item);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);

export const addNotice = createAsyncThunk(
  "notice/addNotice",
  async (data, thunkAPI) => {
    try {
      const response = await NoticeService.addNotice(data);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);

export const updateNotice = createAsyncThunk(
  "notice/updateNotice",
  async (payload, thunkAPI) => {
    try {
      const response = await NoticeService.editNotice(payload);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);

export const deleteNotice = createAsyncThunk(
  "notice/deleteNotice",
  async (id, thunkAPI) => {
    try {
      await NoticeService.deleteNotice(id);
      return id;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);

/* =================== State =================== */

const initialState = {
  loading: false,
  error: null,
  noticeList: [],
  updateSuccess: false,
};

/* =================== Slice =================== */

const noticeSlice = createSlice({
  name: "notice",
  initialState,
  reducers: {
    resetUpdateStatus: (state) => {
      state.updateSuccess = false;
    },
  },

  extraReducers: (builder) => {
    builder

      /* ---------- Get Notice ---------- */
      .addCase(getNotice.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getNotice.fulfilled, (state, action) => {
        state.loading = false;
        state.noticeList = action.payload?.data || [];
      })
      .addCase(getNotice.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      /* ---------- Add Notice ---------- */
      .addCase(addNotice.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(addNotice.fulfilled, (state, action) => {
        state.loading = false;
        if (action.payload?.data) {
          state.noticeList.unshift(action.payload.data);
        }
      })
      .addCase(addNotice.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      /* ---------- Update Notice ---------- */
      .addCase(updateNotice.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.updateSuccess = false;
      })
      .addCase(updateNotice.fulfilled, (state, action) => {
        state.loading = false;
        state.updateSuccess = true;

        const updated = action.payload?.data;
        if (updated?._id) {
          const index = state.noticeList.findIndex(
            (n) => n._id === updated._id
          );
          if (index !== -1) {
            state.noticeList[index] = updated;
          }
        }
      })
      .addCase(updateNotice.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      /* ---------- Delete Notice ---------- */
      .addCase(deleteNotice.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteNotice.fulfilled, (state, action) => {
        state.loading = false;
        state.noticeList = state.noticeList.filter(
          (notice) => notice._id !== action.payload
        );
      })
      .addCase(deleteNotice.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { resetUpdateStatus } = noticeSlice.actions;
export default noticeSlice.reducer;
